let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i7y0D")).then(() => parcelRequire('e0i7w'));